import { call, put, select, fork, all } from 'redux-saga/effects';
import axios from 'axios';
import { SagaIterator } from 'redux-saga';

// @ts-ignore
import { idTokenSelector } from 'services/auth/selectors';
// @ts-ignore
import { takeLatestWithCancel } from 'utils/redux-saga';

import { RequestedLoadReEntryWarningAction } from './types';
import {
    succeededLoadReEntryWarning,
    failedLoadReEntryWarning,
    setReEntryWarning
} from './actions';
import {
    RE_ENTRY_WARNING_LOAD_REQUESTED,
    RE_ENTRY_WARNING_LOAD_CANCELED
} from './constants';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* requestReEntryWarning(
    action: RequestedLoadReEntryWarningAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);
    const url = `${REACT_APP_API_URL}/v1/SprayEvents/reEntryPeriodDays/conflicts`;
    const { entityId, startDate, endDate } = action.payload;

    try {
        const response = yield call(axios, url, {
            method: 'get',
            headers: {
                Authorization: idToken
            },
            params: {
                entityId,
                startDate,
                endDate
            }
        });

        const isWarning = !!response.data.numberOfConflicts;

        yield all([
            put(succeededLoadReEntryWarning(response)),
            put(setReEntryWarning(isWarning))
        ]);
    } catch (error) {
        yield put(failedLoadReEntryWarning(error));
    }
}

export function* watchReEntryWarningRequested(): SagaIterator {
    yield takeLatestWithCancel(
        RE_ENTRY_WARNING_LOAD_REQUESTED,
        RE_ENTRY_WARNING_LOAD_CANCELED,
        requestReEntryWarning
    );
}

export default function* reEntryWarningSagas(): SagaIterator {
    yield fork(watchReEntryWarningRequested);
}
